module.exports = __webpack_public_path__ + "static/media/trash-default.d0bd88c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/trash-default.svg
// module id = 108
// module chunks = 0